import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { ApiService } from './api.service';


@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  userData: any;
  status: any;
  isAdmin: boolean;
  isOrgAdmin: boolean;
  idToken: string;
  isLabUser = false;
  userRole;
  userFirestoreData;
  userOrgId;
  userOrgData: any;

  constructor(private angularFireAuth: AngularFireAuth, private router: Router, private apiService: ApiService) {

    this.isAdmin = false; // default
    this.isOrgAdmin = false; // default

    this.angularFireAuth.authState.subscribe(async user => {

      if (user && user.uid) {

        console.log(user);

        this.userData = user;
        console.log(this.userData);
        const token = await user.getIdTokenResult(); // get the id token
        this.idToken = token.token;
        console.log(token);
        this.userRole = token.claims?.userRole || 'user'; // get the user role
        this.isAdmin = this.userRole === 'superuser'; // check if the user is an admin
        this.isOrgAdmin = this.userRole === 'admin'; // check if the user is an org admin
        this.userFirestoreData = await this.apiService.getUserData(user.uid, this.idToken); // get the user data from firestore
        // dispatch event to other components that user data has been loaded
        window.dispatchEvent(new CustomEvent('user-data-loaded', { detail: this.userFirestoreData }));

        this.userOrgId = token.claims?.orgData?.orgId || this.userFirestoreData.data.orgId; // get the user org id
        this.userOrgData = await this.apiService.getOrgData(this.idToken, this.userOrgId); // get the user org data from firestore
        if (this.userRole === 'labuser') {
          this.isLabUser = true;
        }
        console.log(this.isAdmin, this.isLabUser, this.userRole);
      } else { // if the user is not logged in
        this.userData = null;
      }
    });
  }

  /**
   * Sign out the user
   */
  SignOut() {
    this.angularFireAuth
      .signOut().then(async () => {
      // Sign-out successful.
      await this.router.navigate(['/']);

    });
  }

  /**
   * Get the user's org ID
   */
  async getUserOrgId() {
    const userFirestoreData = await this.apiService.getUserData(this.userData.uid, this.idToken);
    return userFirestoreData.data?.orgId || userFirestoreData.data?.orgData?.orgId;
  }


  async getUserFirestoreData() {
    return await this.apiService.getUserData(this.userData.uid, this.idToken);
  }

  async getUserOrgData(orgId: string) {
    return await this.apiService.getOrgData(this.idToken, orgId);
  }
}
